export interface GuideGroup {
  id: string
  titleKey: string
  introKey: string
  articleSlugs: string[]
}

export const GUIDE_GROUPS: GuideGroup[] = [
  {
    id: 'getting-started',
    titleKey: 'documentation.guides.groups.gettingStarted.title',
    introKey: 'documentation.guides.groups.gettingStarted.intro',
    articleSlugs: ['first-steps', 'download-app']
  },
  {
    id: 'vehicles-management',
    titleKey: 'documentation.guides.groups.vehiclesManagement.title',
    introKey: 'documentation.guides.groups.vehiclesManagement.intro',
    articleSlugs: [
      'vehicles-overview',
      'vehicles-list',
      'vehicles-detail',
      'vehicles-create',
      'vehicles-update',
      'vehicles-delete',
      'vehicles-export-csv'
    ]
  },
  {
    id: 'vehicle-documents-management',
    titleKey: 'documentation.guides.groups.vehicleDocumentsManagement.title',
    introKey: 'documentation.guides.groups.vehicleDocumentsManagement.intro',
    articleSlugs: [
      'vehicle-documents-overview',
      'vehicle-documents-list',
      'vehicle-documents-detail',
      'vehicle-documents-create',
      'vehicle-documents-update',
      'vehicle-documents-delete'
    ]
  },
  {
    id: 'places-management',
    titleKey: 'documentation.guides.groups.placesManagement.title',
    introKey: 'documentation.guides.groups.placesManagement.intro',
    articleSlugs: [
      'places-overview',
      'places-list',
      'places-detail',
      'places-create',
      'places-update',
      'places-delete',
      'places-export-csv'
    ]
  },
  {
    id: 'customers-management',
    titleKey: 'documentation.guides.groups.customersManagement.title',
    introKey: 'documentation.guides.groups.customersManagement.intro',
    articleSlugs: [
      'customers-overview',
      'customers-list',
      'customers-detail',
      'customers-create',
      'customers-update',
      'customers-delete',
      'customers-import',
      'customers-export-csv'
    ]
  },
  {
    id: 'payloads-management',
    titleKey: 'documentation.guides.groups.payloadsManagement.title',
    introKey: 'documentation.guides.groups.payloadsManagement.intro',
    articleSlugs: [
      'payloads-overview',
      'payloads-list',
      'payloads-detail',
      'payloads-create',
      'payloads-update',
      'payloads-delete',
      'payloads-export-csv'
    ]
  },
  {
    id: 'prices-management',
    titleKey: 'documentation.guides.groups.pricesManagement.title',
    introKey: 'documentation.guides.groups.pricesManagement.intro',
    articleSlugs: [
      'prices-overview',
      'prices-create',
      'prices-update',
      'prices-delete',
      'prices-export-csv'
    ]
  },
  {
    id: 'external-drivers-management',
    titleKey: 'documentation.guides.groups.externalDriversManagement.title',
    introKey: 'documentation.guides.groups.externalDriversManagement.intro',
    articleSlugs: [
      'drivers-overview',
      'drivers-list',
      'drivers-detail',
      'drivers-create',
      'drivers-update',
      'drivers-delete'
    ]
  },
  {
    id: 'employees-management',
    titleKey: 'documentation.guides.groups.employeesManagement.title',
    introKey: 'documentation.guides.groups.employeesManagement.intro',
    articleSlugs: [
      'employees-overview',
      'employees-list',
      'employees-detail',
      'employees-create',
      'employees-update',
      'employees-reset-password',
      'employees-deactivate',
      'employees-export-csv'
    ]
  },
  {
    id: 'employee-documents-management',
    titleKey: 'documentation.guides.groups.employeeDocumentsManagement.title',
    introKey: 'documentation.guides.groups.employeeDocumentsManagement.intro',
    articleSlugs: [
      'employee-documents-overview',
      'employee-documents-list',
      'employee-documents-detail',
      'employee-documents-create',
      'employee-documents-update',
      'employee-documents-delete'
    ]
  },
  {
    id: 'expenses-management',
    titleKey: 'documentation.guides.groups.expensesManagement.title',
    introKey: 'documentation.guides.groups.expensesManagement.intro',
    articleSlugs: [
      'expenses-overview',
      'expenses-list',
      'expenses-detail',
      'expenses-create',
      'expenses-update',
      'expenses-delete',
      'expenses-assign-vehicles'
    ]
  },
  {
    id: 'refuels-management',
    titleKey: 'documentation.guides.groups.refuelsManagement.title',
    introKey: 'documentation.guides.groups.refuelsManagement.intro',
    articleSlugs: [
      'refuels-overview',
      'refuels-list',
      'refuels-detail',
      'refuels-create',
      'refuels-update',
      'refuels-delete'
    ]
  },
  {
    id: 'delivery-notes-management',
    titleKey: 'documentation.guides.groups.deliveryNotesManagement.title',
    introKey: 'documentation.guides.groups.deliveryNotesManagement.intro',
    articleSlugs: [
      'delivery-notes-overview',
      'delivery-notes-document-types',
      'delivery-notes-routes-signatures',
      'delivery-notes-list',
      'delivery-notes-detail',
      'delivery-notes-create-carrier',
      'delivery-notes-create-shipper',
      'delivery-notes-create-operator',
      'delivery-notes-update',
      'delivery-notes-delete',
      'delivery-notes-add-image',
      'delivery-notes-bulk-edit',
      'delivery-notes-bulk-download-pdf',
      'delivery-notes-bulk-share',
      'delivery-notes-share',
      'delivery-notes-create-waste-identification'
    ]
  },
  {
    id: 'bills-management',
    titleKey: 'documentation.guides.groups.billsManagement.title',
    introKey: 'documentation.guides.groups.billsManagement.intro',
    articleSlugs: [
      'bills-overview',
      'bills-list',
      'bills-detail',
      'bills-create',
      'bills-create-corrective',
      'bills-edit',
      'bills-assign-prices',
      'bills-custom-lines',
      'bills-retention'
    ]
  },
  {
    id: 'passenger-transport-documents-management',
    titleKey: 'documentation.guides.groups.passengerTransportDocumentsManagement.title',
    introKey: 'documentation.guides.groups.passengerTransportDocumentsManagement.intro',
    articleSlugs: [
      'passenger-transport-documents-overview',
      'passenger-transport-documents-list',
      'passenger-transport-documents-detail',
      'passenger-transport-documents-create',
      'passenger-transport-documents-update',
      'passenger-transport-documents-delete'
    ]
  },
  {
    id: 'load-orders-management',
    titleKey: 'documentation.guides.groups.loadOrdersManagement.title',
    introKey: 'documentation.guides.groups.loadOrdersManagement.intro',
    articleSlugs: [
      'load-orders-overview',
      'load-orders-list',
      'load-orders-detail',
      'load-orders-create',
      'load-orders-update',
      'load-orders-delete',
      'load-orders-create-delivery-note'
    ]
  },
  {
    id: 'dashboards-management',
    titleKey: 'documentation.guides.groups.dashboardsManagement.title',
    introKey: 'documentation.guides.groups.dashboardsManagement.intro',
    articleSlugs: [
      'dashboards-overview',
      'dashboards-company',
      'dashboards-production',
      'dashboards-billing'
    ]
  },
  {
    id: 'company-config-management',
    titleKey: 'documentation.guides.groups.companyConfigManagement.title',
    introKey: 'documentation.guides.groups.companyConfigManagement.intro',
    articleSlugs: [
      'company-config-overview',
      'company-config-delivery-notes',
      'company-config-passenger-transport-documents',
      'company-config-load-orders',
      'company-config-bills',
      'company-config-certificate',
      'company-config-nimas',
      'company-config-developers'
    ]
  },
  {
    id: 'mobile-app',
    titleKey: 'documentation.guides.groups.mobileApp.title',
    introKey: 'documentation.guides.groups.mobileApp.intro',
    articleSlugs: [
      'app-documents-overview',
      'app-delivery-notes-create',
      'app-delivery-notes-document-types',
      'app-delivery-notes-signing',
      'app-delivery-notes-edit',
      'app-delivery-notes-qr',
      'app-delivery-notes-download-pdf',
      'app-delivery-notes-images',
      'app-delivery-notes-copy',
      'app-delivery-notes-delete',
      'app-scan-document',
      'app-scan-external-qr'
    ]
  }
]

export function getGuideGroup(groupId: string): GuideGroup | undefined {
  return GUIDE_GROUPS.find((group) => group.id === groupId)
}

export function getDefaultGuideGroupId(): string {
  return GUIDE_GROUPS[0]?.id ?? 'vehicles-management'
}

export function isPublishedGuideGroupId(groupId: string): boolean {
  return GUIDE_GROUPS.some((group) => group.id === groupId)
}

export function getGuideGroupForSlug(slug: string): GuideGroup | undefined {
  return GUIDE_GROUPS.find((group) => group.articleSlugs.includes(slug))
}
